/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="main-section">
    <div class="wrapp-title">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="section-title m-0" v-t="'checkout.title'"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainSection'
}
</script>
